import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function StarIcon({ color, className }) {
    return (
        <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M5.17003 -0.00976562L4.07315 3.56609H0.486328L3.38211 5.7818L2.27425 9.36862L5.17003 7.15291L8.07679 9.36862L6.96893 5.7818L9.86471 3.56609H6.27789L5.17003 -0.00976562Z"
                fill={color}
            />
        </svg>
    );
}

StarIcon.propTypes = propTypes;
StarIcon.defaultProps = defaultProps;

export default StarIcon;
